import axios from "axios";
import {API_URL} from "./constants";

let route_groups = {
  job_countries: 'job-filters/countries',
  job_contracts: 'job-filters/contracts',
  job_languages: 'job-filters/languages',
  job_list: 'jobs',
  articles: 'articles',
}

export const API_PREFIX = API_URL

/**
 * Filters routes
*/
export const axiosFilters = {
  getCountries: async () => await axios.get(`${API_PREFIX}/${route_groups.job_countries}`),
  getContracts: async () => await axios.get(`${API_PREFIX}/${route_groups.job_contracts}`),
  getLanguages: async () => await axios.get(`${API_PREFIX}/${route_groups.job_languages}`),
  fetchJobs: async (params, token) => {
    return await axios.get(`${API_PREFIX}/${route_groups.job_list}`, {
      params: params,
      cancelToken: token
    })
  }
}

/**
 * Filters routes
*/
export const axiosArticles = {
  fetchArticles: async (params, token) => {
    return await axios.get(`${API_PREFIX}/${route_groups.articles}`, {
      params: params,
      cancelToken: token
    })
  }
}

export const axiosStock = {
  reasons: async () => await axios.get(`api/clearance-stock/overstock-reason`),
  send: async (data) => {
    let formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, value);
    }
    return await axios.post(
      `api/clearance-stock`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
  },
}

export const axiosJobApply = {
  reasons: async () => await axios.get(`api/job-apply/reason`),
  send: async (data) => await axios.post(`api/job-apply`, data),
}
